import { createTheme } from '@mui/material';

const theme = createTheme({
  typography: {
    fontFamily: 'PingFangSC-Regular',
    fontWeightRegular: 400,
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableTouchRipple: true,
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'PingFang SC, sans-serif',
          color: '#383838',
          fontWeight: 400,
          lineHeight: 1.4,
        },
        h1: {
          fontSize: '1.1rem',
          paddingBottom: '0.2rem',
        },
        h2: {
          fontSize: '0.9rem',
          color: '#8B8B8B',
          paddingBottom: '0.2rem',
        },
        body1: {
          fontSize: '0.9rem',
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        label: false,
        notched: false,
      },
      styleOverrides: {
        icon: {
          width: '1.4rem',
          height: '1.4rem',
          right: '0.7rem',
          top: 'calc(50% - 0.7rem)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: '0.9rem',
          '@media (orientation: landscape)': {
            fontSize: '0.9rem',
          },
        },
        input: {
          padding: '0.7rem 1.4rem',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '0.9rem',
          '@media (orientation: landscape)': {
            fontSize: '0.9rem',
          },
        },
      },
    },
    MuiToggleButton: {
      defaultProps: {
        disableTouchRipple: true,
      },
      styleOverrides: {
        root: {
          width: '3.1rem',
          height: '2rem',
          borderColor: '#8B8B8B',
          color: '#8B8B8B',
          padding: 0,
          boxShadow: 'none',
          '&.Mui-selected': {
            backgroundColor: '#0063A0',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#0063A0',
              color: '#fff',
            },
          },
        },
      },
    },
  },
});

export default theme;
